const OFF_BUDGET_MAPPING = {
  instrument: 'Инструменты и оборудование',
  material: 'Расходный материал',
  service: 'Сторонние услуги',
  additional: 'Доп. смета',
}

export const OFF_BUDGET_OPTIONS = Object.entries(OFF_BUDGET_MAPPING).map(([value, label]) => ({
  value,
  label,
}))

export const getOffBudget = (off_budget) => {
  return OFF_BUDGET_MAPPING[off_budget] || ''
}
